import { ActiveObject, resolve } from '../../Container';
import { EditorSession } from '../EditorSession';
import { Selection } from '../Selection';
import { DuplicateInfo } from './DuplicateInfo';

export class DuplicateMechanics extends ActiveObject {

    @resolve(EditorSession) private session!: EditorSession;

    public start = () => this.burden(
        this.session.observe(Selection, (n, o) => {
            if (n.size === 0 || n.size !== o.size) {
                this.session.update(DuplicateInfo, DuplicateInfo.empty);
            }
        })
    );
}
